/* eslint-disable react/display-name */
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Row, Col, Typography, Form, Button, Space, message } from "antd";
import LoginTemplate from "./LoginTemplate";
import { UserOutlined } from "@ant-design/icons";
import { authService } from "../../../configs/constants";
import axios from "axios";
import { useForm } from "react-hook-form";
import { InputField } from "../../atoms/FormElement";
import { isLoggedIn } from "../../../utils/session";
// import { ReCaptcha, loadReCaptcha } from "react-recaptcha-v3";
// import { SITEKEY } from "../../../configs/constants";

const { Text } = Typography;

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [invalidUserFlag, setInvalidUserFlag] = useState(false);
  const [onSuccessCodeSent, setOnSuccessCodeSent] = useState(false);
  const [userName, SetUsername] = useState();
  const navigate = useNavigate();
  // const [tokenCapcha, setReCapcha] = useState();
  const { control, handleSubmit, formState:{errors} } = useForm();
  // const refReCaptcha = useRef(null);

  React.useEffect(() => {
    if (isLoggedIn()) navigate("/properties");
  }, []);
  
  // useEffect(() => {
  //   loadReCaptcha(SITEKEY);
  // }, []);

  // const verifyCallback = (token) => {
  //   // console.log("recaptch", token);
  //   setReCapcha(token);
  // };

  const onFinish = async (values) => {
    setInvalidUserFlag(false);

    const { username } = values;
    const postJson = {
      email: username?.toLowerCase(),
      // recapcha: tokenCapcha,
      usertype: "institutionalLandlord"
    };


    const url = `${authService}/user/forgetpassword`;
    try {
      await axios.post(url, postJson);
      setInvalidUserFlag(false);
      setOnSuccessCodeSent(true);
      window.localStorage.setItem("usernameForCode", username);
      SetUsername(username);
      message.success("OTP sent successfully!");
      // setTimeout(() => {
      //   history.push("/change-password");
      // }, 30 * 1000);
    } catch (e) {
      // refReCaptcha.current.execute();
      const { response } = e;
      // console.log("response",response);
      if (response?.statusText.includes("check the email")) {
        setInvalidUserFlag(true);
      } else {
        message.error(response?.data?.error);
      }
    }
  };

  return (
    <LoginTemplate load={loading}>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Text className="ag-primary RegularFont">Forgot Password</Text>
        </Col>
        <Col span={24}>
          <Form
            name="normal_login"
            className="forgot-password-form text-left"
            onFinish={handleSubmit(onFinish)}
          >
            <InputField
              fieldname="username"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Enter Email",
                size: "large",
                prefix: <UserOutlined className="site-form-item-icon" />,
              }}
              rules={{
                required: "Please input username",
                pattern: {
                  value: /^\S*$/,
                  message: "Input username without space!",
                },
              }}
              validate={errors.username && "error"}
              validMessage={errors.username && errors.username.message}
            />

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                size="large"
              >
                Send code
              </Button>
            </Form.Item>
            {invalidUserFlag && (
              <div className="ant-form-item-explain defaultFont">
                <Text className="ag-success">
                  An email has been sent to this email address with a code you
                  will need to make a new password.
                </Text>
                {/* <Text className="ag-error">
                  There is no account associated with this email address.
                  Re-enter or{" "}
                  <Link to="/signup" className="text-underline">
                    create a new account.
                  </Link>
                </Text> */}
              </div>
            )}
            {onSuccessCodeSent && (
              <div className="ant-form-item-explain defaultFont">
                <Space direction="vertical" size={16}>
                  <Text className="ag-success">
                    An email has been sent to this email address with a code you
                    will need to make a new password.
                  </Text>
                  <Space direction="vertical" size={16}>
                    <Button
                      type="link"
                      className="p-0 property_card_btn"
                      htmlType="button"
                      size="large"
                      onClick={() =>
                        navigate("/change-password",{
                          state: { UserName: userName },
                        })
                      }
                    >
                    <b> I have my code. </b>
                    </Button>
                    <Button
                      type="link"
                      size="large"
                      htmlType="submit"
                      className="p-0 ag-error resend_code"
                    >
                      Did not receive code? Resend now.
                    </Button>
                  </Space>
                </Space>
              </div>
            )}
            {/* <ReCaptcha
              ref={refReCaptcha}
              action="main"
              sitekey={SITEKEY}
              verifyCallback={verifyCallback}
            /> */}
          </Form>
        </Col>
      </Row>
    </LoginTemplate>
  );
};

export default ForgotPassword;
